import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAlert, createIncidentFromAlert } from '../../shared/api/api';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import './CreateIncidentPage.css';

function CreateIncidentPage() {
  const { alertId } = useParams();
  const navigate = useNavigate();

  const [alertData, setAlertData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAlert();
  }, [alertId]);

  const fetchAlert = async () => {
    try {
      const response = await getAlert(alertId);
      setAlertData(response.data);
    } catch {
      setError('Failed to load alert details.');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    setCreating(true);
    setError('');
    try {
      const response = await createIncidentFromAlert(alertId);
      const incident = response.data;
      navigate(`/incidents/${incident.service}/${incident.incident_id}`, { replace: true });
    } catch {
      setError('Failed to create incident.');
      setCreating(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="page-container">
        <LoadingSpinner message="Loading alert details..." />
      </div>
    );
  }

  return (
    <div className="page-container">
      <button className="btn-back" onClick={handleCancel}>
        {'\u2190'} Back
      </button>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="ci-page">
        <div className="card ci-card">
          <h1 className="ci-title">Create Incident</h1>
          <p className="ci-subtitle">You are about to create a new incident from the following alert.</p>

          {alertData && (
            <div className="ci-alert-summary">
              <div className="ci-summary-row">
                <span className="ci-summary-label">Alert</span>
                <span className="ci-summary-value">{alertData.alarm_name}</span>
              </div>
              <div className="ci-summary-row">
                <span className="ci-summary-label">Service</span>
                <span className="ci-summary-value">{alertData.service}</span>
              </div>
              <div className="ci-summary-row">
                <span className="ci-summary-label">Severity</span>
                <span className="ci-summary-value">{alertData.severity}</span>
              </div>
              <div className="ci-summary-row">
                <span className="ci-summary-label">State</span>
                <span className="ci-summary-value">{alertData.state}</span>
              </div>
              {alertData.alarm_description && (
                <div className="ci-summary-row ci-summary-row--full">
                  <span className="ci-summary-label">Description</span>
                  <span className="ci-summary-value">{alertData.alarm_description}</span>
                </div>
              )}
            </div>
          )}

          <div className="ci-confirm-box">
            <p className="ci-confirm-message">
              Are you sure you want to create an incident from this alert? This will create a new active incident.
            </p>
            <div className="ci-actions">
              <button className="btn btn-secondary" onClick={handleCancel} disabled={creating}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleConfirm} disabled={creating}>
                {creating ? 'Creating...' : 'Confirm & Create'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateIncidentPage;
